import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

const useAccountCreationEmailVerificationSent = () => {
  const { accountCreationState } = useAccountCreationData();

  // Get the email address that was used for the invite
  // For users over 16, use email from userInfoData; for users under 16, use youthEmail from youthContactData
  const getEmailAddress = () => {
    return accountCreationState?.userInfoData?.email || accountCreationState?.youthContactData?.youthEmail || '';
  };

  return {
    emailAddress: getEmailAddress()
  };
};

export default useAccountCreationEmailVerificationSent;